module.exports = __webpack_public_path__ + "img/logo.7cb633f7.png";